import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StandardModal from "../../Fundamentals/Modal/StandardModal";
import { Dropdown } from "../../FormComponents/Dropdown";
import SkynetForm from "../../Fundamentals/Form/SkynetForm";
import useModal from "../../../Hooks/useModal";
import formActions from "../../../Actions/formActions";
import forms from "../../../Constants/forms";
import * as formValidationRules from "../../../Constants/formValidationRules";

export default function AddVossDiscountModal({ discounts, onAddDiscount }) {
    const { t } = useTranslation();
    const { closeModal } = useModal();
    const dispatch = useDispatch();
    const form = useSelector(state => state.FormReducer.forms[forms.addVossDiscount]);

    const monthOptions = [...Array(25)].map((_, i) => ({
        id: i + 1,
        name: t('vossDiscountOptions.monthCount', { count: i + 1 })
    }));

    useEffect(() => {
        dispatch(formActions.startFormEditing(forms.addVossDiscount, {
            discountAgreementId: null,
            months: 12
        }, formValidationRules.AddVossDiscount));

        return () => {
            dispatch(formActions.cancelFormEditing(forms.addVossDiscount));
        };
    }, []);

    const handleSubmit = () => {
        dispatch(formActions.submitForm(form, () => {
            if (form.data.discountAgreementId && onAddDiscount) {
                onAddDiscount({
                    discountAgreementId: form.data.discountAgreementId,
                    months: Number(form.data.months)
                });
                closeModal();
            }
        }));
    };

    const onChange = (key, value) => {
        dispatch(formActions.changeMultiFormField(form, key, value));
    };

    if (!form) return null;

    return (
        <StandardModal title={t('vossDiscountOptions.addDiscount')} onSubmit={handleSubmit}>
            <SkynetForm onSubmit={handleSubmit}>
                <fieldset className="d-grid col-12 gap-12">
                    <Dropdown
                        required
                        label={t('vossDiscountOptions.chooseDiscountAgreement')}
                        options={discounts || []}
                        value={form.data.discountAgreementId}
                        onChange={(value) => onChange("discountAgreementId", value)}
                        placeholder={t('vossDiscountOptions.chooseDiscountAgreement')}
                    />
                    <Dropdown
                        required
                        label={t('vossDiscountOptions.duration')}
                        options={monthOptions}
                        value={form.data.months}
                        onChange={(value) => onChange("months", value)}
                        placeholder={t('vossDiscountOptions.selectDuration')}
                    />
                </fieldset>
            </SkynetForm>
        </StandardModal>
    );
}
